import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { InvoiceScheduleEnum } from "../../data/enums";

export namespace CustomerImportValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const ObtainRecord = defineValidation(BaseRecordSchema);

    export const UploadRecord = defineValidation(BaseRecordSchema);

    export const Upload = defineValidation(
        v.object({
            file: baseVals.string(),
        }),
    );

    export const Create = defineValidation(
        v.object({
            file: baseVals.string(),
            name: baseVals.string(),
        }),
    );
}

export const CustomerImportEntityValidation = defineValidation(
    v.object({
        id: baseVals.string("ID Pelanggan"),
        identityNumber: baseVals.identityNumber("No. KTP"),
        name: baseVals.string("Nama"),
        email: v.optional(baseVals.email()),
        address: baseVals.string("Alamat"),
        phone: v.optional(baseVals.phoneNumberOnly()),
        area: v.optional(baseVals.string()),
        coordinate: v.optional(baseVals.coordinate()),
        product: baseVals.string("Kode Produk"),
        rateLimit: v.optional(baseVals.string()),
        activatedAt: baseVals.date("Tanggal Aktivasi"),
        latestPaymentAt: baseVals.date("Tanggal Pembayaran Terakhir"),
        invoiceSchedule: v.pipe(
            v.picklist(InvoiceScheduleEnum.values, "Format Jadwal Tagihan tidak valid."),
            v.check((input) => input !== "C", "Format Jadwal Tagihan tidak valid."),
        ),
        radiusAccountUsername: baseVals.string("Username Akun Radius"),
        radiusAccountPassword: baseVals.string("Password Akun Radius"),
        isLimited: baseVals.binaryBoolean("Akses Terbatas"),
        notes: v.optional(baseVals.string()),
    }),
);

export type CustomerImportEntity = v.InferOutput<typeof CustomerImportEntityValidation.schema>;
